import { Component, h, Prop } from "@stencil/core";

@Component({
    tag: "snt-source-list",
    styleUrl: "source-list-component.scss",
    shadow: false,
})
export class SourceListComponent {
    static readonly TAG_NAME = "snt-source-list";

    private RETURN = 13;

    @Prop() panelId: string;
    @Prop() sourceHeading: string;

    private buttonEl: HTMLButtonElement;
    private panelEl: HTMLElement;
    private iconEl: HTMLElement;

    private handleKeydown(event: KeyboardEvent) {
        switch (event.keyCode) {
            case this.RETURN:
                this.toggleExpand();
                event.stopPropagation();
                event.preventDefault();
                break;
            default:
                break;
        }
    }

    private toggleExpand() {
        if (this.buttonEl.getAttribute('aria-expanded') === 'true') {
            this.buttonEl.setAttribute('aria-expanded', 'false');
        } else {
            this.buttonEl.setAttribute('aria-expanded', 'true');
        }
        this.buttonEl.classList.toggle('expanded');
        this.toggleContent();
    }

    private toggleContent() {
        this.panelEl.classList.toggle('open');
        this.panelEl.classList.toggle('close');
        this.iconEl.classList.toggle('icon-icon_legalAccordion_plus');
        this.iconEl.classList.toggle('icon-icon_legalAccordion_minus');
    }

    render() {
        return (
            <div class="spacings">
                <button
                    ref={(el) => (this.buttonEl = el as HTMLButtonElement)}
                    onKeyDown={this.handleKeydown.bind(this)}
                    onClick={this.toggleExpand.bind(this)}
                    aria-expanded="false"
                    aria-controls={this.panelId}
                >
                    <span ref={(el) => (this.iconEl = el as HTMLElement)} class="expand-icon icon-font icon-icon_legalAccordion_plus"></span>
                    {this.sourceHeading}
                </button>
                <div class="source-panel close"
                    ref={(el) => (this.panelEl = el as HTMLElement)}
                    id={this.panelId}
                >
                    <slot></slot>
                </div>
            </div>
        );
    }
}
